var React = require('react');

function LeftArrowGreen (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Group"),React.createElement("g",{"id":"//-Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","key":1},React.createElement("g",{"id":"icons/Navigation/Arrow-Left","transform":"translate(-4.000000, -5.000000)","stroke":"#57c88c","strokeWidth":"2"},React.createElement("g",{"id":"Group","transform":"translate(5.000000, 6.000000)"},[React.createElement("path",{"d":"M6.42857065,12.5 L0,6.25000105 L6.42857065,0","id":"arrow-/-chevron","key":0}),React.createElement("line",{"x1":"0.5","y1":"6.5","x2":"13.5","y2":"6.5","id":"Line","key":1})])))]);
}

LeftArrowGreen.defaultProps = {"width":"16px","height":"15px","viewBox":"0 0 16 15","version":"1.1"};

module.exports = LeftArrowGreen;

LeftArrowGreen.default = LeftArrowGreen;
